import Button from './Button.vue';

export default Button;



// WEBPACK FOOTER //
// ./src/pages/profile/components/button/index.ts